import random from "lodash/random"
import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import {
  GET_BULK_PICKUP_LOCATIONS_PENDING,
  GET_BULK_PICKUP_LOCATIONS_FAILED,
  GET_BULK_PICKUP_LOCATIONS_FULFILLED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: GET_BULK_PICKUP_LOCATIONS_PENDING,
})

export const failedAC = () => ({
  type: GET_BULK_PICKUP_LOCATIONS_FAILED,
})

export const fulfilledAC = (data) => ({
  type: GET_BULK_PICKUP_LOCATIONS_FULFILLED,
  payload: data,
})

/**
 * Fetches facility locations based on address and language preference, then dispatches actions based on the response.
 * @param {string} street - The street part of the address for the facility search.
 * @param {string} city - The city part of the address for the facility search.
 * @param {string} state - The state part of the address for the facility search.
 * @param {string} country - The country part of the address for the facility search.
 * @param {string} zipcode - The zipcode part of the address for the facility search.
 * @param {string} lang - The language preference for the facility search.
 */
export const getFacilityLocations =
  (street, city, state, country, zipcode, lang) => (dispatch) => {
    dispatch(pendingAC())

    const api = `OAKLAND_BULK_PICKUP_FACILITY_SEARCH`

    const template = URITemplate(urls.url[api])

    const url = template.expand({
      street,
      city,
      state,
      country,
      zipcode,
      distance: 100,
      lang,
    })

    const config = {
      headers: {
        "Request-Tracking-Id": random(1, 999999999),
      },
    }

    return axios
      .create(config)
      .get(url)
      .then((response) => {
        dispatch(fulfilledAC(response.data))
        return response.data
      })
      .catch(() => {
        dispatch(failedAC())
      })
  }
